import { useEffect, useState } from "react";

import Container from "@mui/material/Container";
import { LinearProgress, Theme, useTheme } from "@mui/material";

import Page404 from "../../Utils/Custom/Page404";

import ManageResetPassword from "./components/ManageResetPassword";

export default function RedirectEmailActions() {
  const theme: Theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState<string>("");
  const [oobCode, setOobCode] = useState<string>("");

  const [specialCode, setSpecialCode] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  useEffect(() => {
    setLoading(true);
    const url = new URL(window.location.href);

    const mode = url.searchParams.get("mode") || "";

    const oobCode = url.searchParams.get("oobCode") || "";

    const specialcode = url.searchParams.get("key") || "";
    const email = url.searchParams.get("email") || "";

    setMode(mode);
    setOobCode(oobCode);

    setSpecialCode(specialcode);
    setEmail(email);
    setLoading(false);
  }, []);

  /////////////////////////////////////////
  /*Design depending of the mode*/
  const design = () => {
    let section: any;
    switch (mode) {
      case "resetPassword":
        section = <ManageResetPassword emailPasswordToReset={email} oobCode={oobCode} />;
        break;
      default:
        section = <Page404 />;
        break;
    }
    return (
      <Container component="main" maxWidth="xs">
        <div
          style={{
            marginTop: theme.spacing(15),
            display: "flex",
            alignItems: "center",
          }}
        >
          {section}
        </div>
        {loading ? <LinearProgress /> : null}
      </Container>
    );
  };
  return design();
}
